import { globs } from "../../../../services/globs";

const key = "allow-inventory-management";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const allowInventory = { Effect: "Allow", Path: globs.entityTypes.byType("DEALER").inventory.byCode("*").read };
	role.Actions.push(allowInventory);

};

export const allowInventoryManagement = [key, applicable, modify];